module.exports = __webpack_public_path__ + "static/media/get-data.fe3be1cb.png";